var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-fragment',{on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v(_vm._s(_vm.$t(_vm.i18n.go_to_details)))])
}
var staticRenderFns = []

export { render, staticRenderFns }